import { Phone, ArrowRight } from "lucide-react";
import { BRAND, HERO_IMAGE } from "@/data/content";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Modern Las Vegas home interior"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/85" />
        <div className="absolute inset-0 grain" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 md:pt-44 pb-28 md:pb-36 min-h-[100svh] flex flex-col justify-between">
        <div className="max-w-3xl">
          <span
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-3 text-[10px] tracking-[0.4em] uppercase text-[#C8A44D]"
          >
            <span className="w-8 h-px bg-[#C8A44D]" />
            Las Vegas Valley · Premium Handyman
          </span>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-white mt-6 text-[clamp(2.6rem,6vw,5.4rem)] leading-[1.02] tracking-tight"
          >
            Las Vegas Handyman <br />
            <span className="italic text-[#C8A44D]">Services You Can</span> <br />
            Count On.
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-7 text-white/80 text-lg md:text-xl max-w-2xl font-light leading-relaxed"
          >
            Professional home repairs, installations, assembly, painting, and
            maintenance — done right the first time. Reliable craftsmanship for
            the entire Las Vegas Valley.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#estimate"
              data-testid="hero-primary-cta"
              className="btn-gold inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-sm font-medium tracking-wide"
            >
              Get a Free Estimate
              <ArrowRight size={16} strokeWidth={1.75} />
            </a>
            <a
              href={`tel:${BRAND.phoneRaw}`}
              data-testid="hero-secondary-cta"
              className="btn-outline-light inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-sm font-medium tracking-wide"
            >
              <Phone size={15} strokeWidth={1.75} />
              Call {BRAND.phone}
            </a>
          </div>
        </div>

        {/* Bottom luxury strip */}
        <div className="hidden md:grid grid-cols-4 gap-12 mt-20 pt-10 border-t border-white/15">
          {[
            ["Licensed & Insured", "Fully credentialed"],
            ["Same-Day Quotes", "Most jobs scheduled in 24h"],
            ["Satisfaction Guaranteed", "We make it right"],
            ["Owner-Operated", "By Deve'Naire Broady"],
          ].map(([t, s], i) => (
            <div key={i} className="text-white">
              <div className="text-[10px] tracking-[0.32em] uppercase text-[#C8A44D]">
                {t}
              </div>
              <div className="mt-2 text-sm font-light text-white/75">{s}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 right-6 z-10 hidden md:flex items-center gap-3 text-white/60 text-[10px] tracking-[0.32em] uppercase">
        Scroll <span className="block w-10 h-px bg-white/40" />
      </div>
    </section>
  );
}
